import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, CardBody, Card, CardHeader, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import AddEditWarehouseModal from './Add_Edit/AddEditWarehouse';
import DeleteWarehouseModal from './Delete/DeleteWarehouse';
import { getWarehouseList, synchronizeWarehouse } from '../../../slices/warehouse/thunk';

const WarehouseList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorWarehouse = createSelector(
		state => state.Warehouses,
		data => ({
			warehouseList: data.warehouseList,
			isLoadingList: data.isLoadingList,
			isWarehouseSuccess: data.isWarehouseSuccess,
			isLoadingWarehouseList: data.isLoadingWarehouseList,
		})
	);

	const { warehouseList, isLoadingList, isLoadingWarehouseList } = useSelector(selectorWarehouse);


	useEffect(() => {
		dispatch(getWarehouseList());
	}, []);


	const [dataWarehouse, setDataWarehouse] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Warehouse
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = warehouse => {
		setDataWarehouse(warehouse);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = warehouse => {
		setDataWarehouse(warehouse);
		handleToggleModal();
	};

	function synchronize() {
		dispatch(synchronizeWarehouse());
	}

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'warehouse',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const warehouseData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(warehouseData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},

			{ header: 'Código SAP', accessorKey: 'code_sap', }, 
			{ header: 'Nombre', accessorKey: 'name' },
			{ header: 'Tipo', accessorKey: 'warehouse_type.name', },
			{ header: 'Empresa', accessorKey: 'company.name', },
			{ header: 'Descripción', accessorKey: 'description', },

			{
				header: 'Establecimiento',
				accessorKey: 'establishment.name',

				Cell: ({ row }) => {
					const establishmentData = row?.original?.feeding_barges?.establishment || row?.original?.establishment;
					const establishmentName = establishmentData?.name || '-';
					const establishmentId = establishmentData?._id || row?.original?.establishment_id;

					return establishmentId && row?.original?.establishment?.name ? (
						<span
							onClick={() => window.open(`/establishment/summary/${establishmentId}`, '_blank')}
							style={{
								cursor: "pointer",
								color: "var(--vz-primary)",
								textDecoration: "none",
								fontWeight: "bold"
							}}
						>
							<i className="ri-links-line"></i> {establishmentName}
						</span>
					) : (
						<span>
							{establishmentName}
						</span>
					);
				},
			},
			{
				header: 'RESPEL',
				accessorKey: 'respel',

				width: 10,
				Cell: ({ row }) => {
					return (
						<input
							className='form-check-input'
							role='switch'
							type='checkbox'
							id='respel'
							name='respel'
							disabled
							checked={row.original.respel}
						/>
					);
				},
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										// { <button
										// 	className='btn btn-label btn-primary'
										// 	onClick={() => {
										// 		setIsEdit(false);
										// 		setDataWarehouse({});
										// 		handleToggleModal();
										// 	}}
										// >
										// 	<i className={`${Icons.plus} label-icon`}></i>{' '}
										// 	Crear Bodega
										// </button> }
										// <button className='btn btn-label btn-primary' disabled={isLoadingWarehouseList} onClick={() => { synchronize(); }}>
										// 	{isLoadingWarehouseList ? (<i className="label-icon"><Spinner size='sm' /></i>) : <i className="icon-refresh-cw label-icon"></i>} Sincronizar con SAP
										// </button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={warehouseList || []}
								isLoadingData={isLoadingList}
								nameFile={'estanque_de_combustible'}
								customToolbarActions={[
									{
										label: 'Sincronizar',
										icon: Icons.refresh,
										className: 'gap-1',
										onClick: () => { synchronize(); },
										title: 'Sincronizar con SAP',
										disabled: isLoadingWarehouseList
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditWarehouseModal
				dataWarehouse={dataWarehouse}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteWarehouseModal
				dataWarehouse={dataWarehouse}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default WarehouseList;
